export default __webpack_public_path__ + "../staticImages/winefinder-sprite-taste-05-2x.png";